/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForAiBilling extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForAiBilling.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForAiBilling>): ProgressDetailsForAiBilling {
        let obj = Object.assign(new ProgressDetailsForAiBilling(), model);
        ProgressDetailsForAiBilling.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForAiBilling>): ProgressDetailsForAiBilling {
        if (!model) return null;
        return ProgressDetailsForAiBilling.newInstance(<ProgressDetailsForAiBilling> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForAiBilling) {
        if (!obj) return;

        models.ProgressDetailsForAiBilling.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForAiBilling): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForAiBilling.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.processing_memory) {
            models.BaseCostProcessingMemory.fixupPrototype(this.processing_memory);
        }
    }

    /**
     * AI caller-attribution incremental watermark
     */
    processing_memory: models.BaseCostProcessingMemory;

}
